// extracted by mini-css-extract-plugin
module.exports = {"Component":"CalendarComponent_Component__3YzZB"};